import { memo, useMemo } from 'react'
import ConditionalSection from '../ConditionalSection'
import SectionWrapper from '../SectionWrapper'

const ConfigurableSections = memo(
  ({ data, conditions, sections, className, ...props }) => {
    const renderedSections = useMemo(() => {
      return sections.map((section, index) => {
        const {
          key,
          condition,
          component: Component,
          props: componentProps = {},
          children,
          title,
          titleId,
          wrapper: Wrapper = ConditionalSection,
          ...sectionProps
        } = section

        const conditionValue =
          typeof condition === 'string' ? conditions[condition] : condition

        if (Wrapper === SectionWrapper) {
          return (
            <SectionWrapper
              key={key || index}
              className={className}
              title={title}
              titleId={titleId}
              {...sectionProps}
              {...props}
            >
              {Component ? (
                <Component {...componentProps} data={data} />
              ) : (
                children
              )}
            </SectionWrapper>
          )
        }

        return (
          <ConditionalSection
            key={key || index}
            condition={conditionValue}
            className={className}
            title={title}
            titleId={titleId}
            {...sectionProps}
            {...props}
          >
            {Component ? (
              <Component {...componentProps} data={data} />
            ) : (
              children
            )}
          </ConditionalSection>
        )
      })
    }, [sections, conditions, data, className, props])

    return <>{renderedSections}</>
  }
)

export default ConfigurableSections
